module.exports = __webpack_public_path__ + "assets/img/link.4ee5b00f.png";